const actions = {
  GET_AREAS_REQUEST: "GET_AREAS_REQUEST",
  GET_AREAS_SUCCESS: "GET_AREAS_SUCCESS",

  FILTER_BY_AREAS_REQUEST: "FILTER_BY_AREAS_REQUEST",
  FILTER_BY_AREAS_SUCCESS: "FILTER_BY_AREAS_SUCCESS",

  FILTER_FOR_ONE_AREA_REQUEST: "FILTER_FOR_ONE_AREA_REQUEST",
  FILTER_FOR_ONE_AREA_SUCCESS: "FILTER_FOR_ONE_AREA_SUCCESS",

  getAreas: (restaurantId, log) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_AREAS_REQUEST,
        restaurantId,
        log,
      });
    };
  },

  getTurnOverByAreas: (filteredAreaIds, startDate, endDate) => {
    return (dispatch) => {
      dispatch({
        type: actions.FILTER_BY_AREAS_REQUEST,
        filteredAreaIds,
        startDate,
        endDate,
      });
    };
  },

  getTurnOverForOneArea: (filteredAreaIds, startDate, endDate) => {
    return (dispatch) => {
      dispatch({
        type: actions.FILTER_FOR_ONE_AREA_REQUEST,
        filteredAreaIds,
        startDate,
        endDate,
      });
    };
  },
};
export default actions;
